import type { ScanStatus } from "./sites";

export enum ProductShape {
  CYLINDRICAL = "cylindrical",
  RECTANGULAR = "rectangular",
}

export interface CreateProductPayload {
  name?: string;
  description?: string | null;
  sku?: string;
  tare_weight?: number | null;
  filling_capacity?: number | null;
  variant?: string | null;
  cost?: number | null;
  retail_price?: number | null;
  procurement_time?: number | null;
  dwell_time?: number | null;
  /** Canonical kg. */
  weight?: number | null;
  /** Canonical cm. */
  length?: number | null;
  /** Canonical cm. */
  height?: number | null;
  /** Canonical cm. */
  width?: number | null;
  shape?: ProductShape | null;
  /** Canonical cm, for cylindrical shapes only. */
  diameter?: number | null;
  image_url?: string | null;
  /** Hex color, e.g. `#3f81ef`. */
  color?: string | null;
  customize_columns?: Record<string, string>;
  scan_statuses?: ScanStatus[];
}

export interface Product {
  id: number;
  name: string;
  description: string;
  sku: string;
  tare_weight: number | undefined;
  filling_capacity: number | undefined;
  variant: string;
  cost: number;
  retail_price: number;
  procurement_time?: number | null;
  dwell_time?: number | null;
  weight?: number | null;
  length?: number | null;
  height?: number | null;
  width?: number | null;
  shape?: ProductShape | null;
  diameter?: number | null;
  image_url?: string | null;
  color?: string | null;
  customize_columns: Record<string, string>;
  created_at: string;
  updated_at: string;
  /** List endpoint only. */
  number_of_items: number;
  /** List endpoint only. */
  status_counts: Record<string, number>;
  scan_statuses: ScanStatus[];
  /** List endpoint only. */
  number_of_sites: number;
  last_moved?: string | null; // ISO string — most recent status change across items
}

/** GET /product/:id/analytics — counts only, computed in SQL. */
export interface ProductAnalytics {
  totalItems: number;
  bySite: { id: number; name: string; count: number }[];
  byStatus: Record<string, number>;
}
